import Head from "next/head";
import Header from "@/shared/components/Header";
import Footer from "@/shared/components/Footer";
import MetaTags from "@/shared/components/MetaTags";
import React, { useState } from 'react';
import styles from './styles.module.css';
import BannerHorizontalChico from "@/widgets/Banner/Templates/BannerHorizontalChico";
import PagegrowlerList from "@/widgets/Listado/Templates/PagegrowlerList";
import WidgetCotizacionesGoogle from "./WidgetCotizacionesGoogle";
const Monedas = (props) => {
    let menues = props.menu ? props.menu : [];
    const [open, setOpen] = useState(false);
    const {
        content
    } = props;
    return (
        <>
            <Head>
                <meta name="og:image" property="og:image" content="https://www.ellitoral.com/collections/img-redes-vista-previa/monedas___68765e6223845b001a56abea.jpg" />
                <meta name="title" content={`Cotizaciones de Monedas`} />
                <title>Cotizaciones | Monedas | Dolar Hoy | Dolar Blue | Doglar Oficial</title>
                <meta name="description"  content="Mercados, monedas, cotizaciones, dolar blue, ccl, mep. Todo en un solo lugar. "/>
                <link rel="image_src" href="https://www.ellitoral.com/collections/img-redes-vista-previa/monedas___68765e6223845b001a56abea.jpg" />
                <meta httpEquiv="refresh" content="600" />
                <link rel="canonical" href={process.env.NEXT_PUBLIC_DOMAIN_URL + `/monedas`} />
                <MetaTags metas={props.meta} />
            </Head>
            <Header menues={menues} isOpenSidePanel={(open) => setOpen(open)} />
            <div className={`${styles['parent']}`} itemScope itemType="https://schema.org/NewsArticle">
                <div className={`${styles['main-container']}`}>
                    {!props.preview && <BannerHorizontalChico bannerId={'top'} />}
                    <div className={`${styles['container']}`}>
                        <div className={`${styles['detail-left']}`}>
                            <WidgetCotizacionesGoogle values={content}/>
                        </div>
                        <div className={`${styles['detail-right']}`}>
                            <PagegrowlerList url='column-lilanews' />
                        </div>
                    </div>
                    <div className={`${styles['detail-full']}`}>

                    </div>
                </div>
            </div>
            <div style={{ clear: "both" }}>
                <Footer />
            </div>
        </>
    )
}

export default Monedas;